var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMemo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.49992H12.35C12 1.53325 11.0833 0.833252 10 0.833252C8.91667 0.833252 8 1.53325 7.65 2.49992H4.16667C3.25 2.49992 2.5 3.24992 2.5 4.16659V15.8333C2.5 16.7499 3.25 17.4999 4.16667 17.4999H15.8333C16.75 17.4999 17.5 16.7499 17.5 15.8333V4.16659C17.5 3.24992 16.75 2.49992 15.8333 2.49992ZM10 2.29159C10.3417 2.29159 10.625 2.57492 10.625 2.91659C10.625 3.25825 10.3417 3.54159 10 3.54159C9.65833 3.54159 9.375 3.25825 9.375 2.91659C9.375 2.57492 9.65833 2.29159 10 2.29159ZM7.58333 14.1666H5.83333V12.3833L10.8 7.41658L12.5667 9.18325L7.58333 14.1666ZM14.0417 7.72492L13.1583 8.60825L11.3917 6.84159L12.275 5.95825C12.4417 5.79159 12.7 5.79159 12.8667 5.95825L14.0417 7.13325C14.2083 7.29992 14.2083 7.55825 14.0417 7.72492Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemo);
export default __webpack_public_path__ + "static/media/icon_memo.00168cda9ba483ea9bdd19308b09a64d.svg";
export { ForwardRef as ReactComponent };